import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ScrollToTop from "@/components/ScrollToTop";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Yachts from "@/pages/Yachts";
import YachtDetail from "@/pages/YachtDetail";
import Book from "@/pages/Book";
import Checkout from "@/pages/Checkout";
import BookingConfirmation from "@/pages/BookingConfirmation";
import About from "@/pages/About";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

import AdminGate from "@/components/admin/AdminGate";
import AdminLayout from "@/components/admin/AdminLayout";
import AdminLogin from "@/pages/admin/Login";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminYachtList from "@/pages/admin/YachtList";
import AdminYachtEdit from "@/pages/admin/YachtEdit";
import AdminBookingList from "@/pages/admin/BookingList";
import AdminBookingDetail from "@/pages/admin/BookingDetail";
import AdminCalendar from "@/pages/admin/Calendar";
import AdminCustomerList from "@/pages/admin/CustomerList";
import AdminSettings from "@/pages/admin/Settings";

/** Public site pages get the public Layout. Admin pages skip the public Nav
 *  / Footer and use their own AdminLayout inside AdminGate. */
function AppRoutes() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  if (isAdmin) {
    return (
      <Routes>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin/*"
          element={
            <AdminGate>
              <AdminLayout>
                <Routes>
                  <Route index element={<AdminDashboard />} />
                  <Route path="yachts" element={<AdminYachtList />} />
                  <Route path="yachts/new" element={<AdminYachtEdit />} />
                  <Route path="yachts/:id" element={<AdminYachtEdit />} />
                  <Route path="bookings" element={<AdminBookingList />} />
                  <Route path="bookings/:id" element={<AdminBookingDetail />} />
                  <Route path="calendar" element={<AdminCalendar />} />
                  <Route path="customers" element={<AdminCustomerList />} />
                  <Route path="settings" element={<AdminSettings />} />
                  <Route path="*" element={<Navigate to="/admin" replace />} />
                </Routes>
              </AdminLayout>
            </AdminGate>
          }
        />
      </Routes>
    );
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/yachts" element={<Yachts />} />
        <Route path="/yachts/yacht-one" element={<Navigate to="/yachts/68-azimut" replace />} />
        <Route path="/book/yacht-one" element={<Navigate to="/book/68-azimut" replace />} />
        <Route path="/yachts/:slug" element={<YachtDetail />} />
        <Route path="/book/:slug" element={<Book />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/booking-confirmation/:conf" element={<BookingConfirmation />} />
        <Route path="/about" element={<About />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <AppRoutes />
        <Toaster richColors position="top-center" />
      </BrowserRouter>
    </div>
  );
}
